module.exports = __webpack_public_path__ + "static/media/turkey.bc470e6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/turkey.png
// module id = 46
// module chunks = 0